import React from 'react'
import { useSelector } from 'react-redux'

import { DepartmentsPanel } from './DepartmentsPanel/DepartmentsPanel'
import { ProjectsPanel } from './ProjectsPanel/ProjectsPanel'
import { usePanel } from './hooks'
import styles from './Panel.module.scss'
import { getLocation } from 'ducks/router'
import { MembersPanel } from './MembersPanel/MembersPanel'
import { ManageUserModal } from 'components/modals/ManageUserModal/ManageUserModal'
import { DeleteUserModal } from 'components/modals/DeleteUserModal/DeleteUserModal'

const Panel = () => {
  const {
    payload: { pk, id },
  } = useSelector(getLocation)

  const {
    state: {
      search,
      members,
      selectedUser,
      isSearchFocused,
      isManageUserOpen,
      isDeleteUserOpen,
      isEditMode,
    },
    handlers: {
      setUser,
      setSearch,
      setIsSearchFocused,
      handleManageUserClose,
      handleManageUserConfirm,
      handleManageUserOpen,
      handleDeleteUserClose,
      handleDeleteUserConfirm,
      handleDeleteUserOpen,
    },
  } = usePanel({ pk: Number(pk) })

  return (
    <div className={styles.panelContainer}>
      <MembersPanel
        state={{
          selectedUser,
          search,
          members,
          isSearchFocused,
        }}
        handlers={{
          setUser,
          setSearch,
          setIsSearchFocused,
          handleManageUserOpen,
        }}
      />
      {id != null ? (
        <ProjectsPanel
          id={Number(id)}
          pk={Number(pk)}
          selectedUser={selectedUser}
          setUser={setUser}
        />
      ) : (
        <DepartmentsPanel
          {...{
            pk,
            selectedUser,
            handleManageUserOpen,
          }}
        />
      )}
      <ManageUserModal
        onCancel={handleManageUserClose}
        onClose={handleManageUserClose}
        onConfirm={handleManageUserConfirm}
        handleDeleteUserOpen={handleDeleteUserOpen}
        isOpen={isManageUserOpen}
        {...{ user: isEditMode ? selectedUser : undefined }}
      />
      <DeleteUserModal
        onCancel={handleDeleteUserClose}
        onClose={handleDeleteUserClose}
        onConfirm={handleDeleteUserConfirm}
        userName={`${selectedUser?.first_name} ${selectedUser?.last_name}`}
        isOpen={isDeleteUserOpen}
      />
    </div>
  )
}

export default Panel
